<template>
    <section class="mini-component-what-will-i-learn">
        <div class="jumbotron pt-3 pb-3 rtl text-right  bg-light panel-card">
            <p class="text-dark ">اهداف دوره </p>
            <div class="container-fluid">
                <div class="row">
                    <div class="col-md-12 mb-4" v-for="(item,index) in items" :key="index">
                        <div class="d-flex flex-column">
                            <p class="d-inline mb-0 qustion font-16">
                            <i class="d-inline  flaticon-check-square text-info"></i>
                                {{item.question}}
                            </p>
                            <p class="d-inline mb-0">
                                {{item.answer}}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
  name: 'what-will-i-learn',
  props: {
    items: {
      type: Array,
      default: () => { }
    }
  }
}
</script>

<style lang="less">
.mini-component-what-will-i-learn {
    .qustion{
        font-weight: bold;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/min-component/what-will-i-learn.vue